<script setup lang="ts">
import { computed } from 'vue';

import BaseIcon from '@/components/base/BaseIcon.vue';
import type { IconSize } from '@/utils/svg';

const props = withDefaults(
  defineProps<{
    size?: IconSize | [IconSize, IconSize];
    direction?:
      | 'up'
      | 'down'
      | 'left'
      | 'right'
      | 'top-right'
      | 'top-left'
      | 'bottom-right'
      | 'bottom-left';
  }>(),
  {
    size: 24 as IconSize,
    direction: 'left',
  },
);

const directionClass = computed(() => {
  switch (props.direction) {
    case 'up':
      return 'transform rotate-90';
    case 'down':
      return 'transform -rotate-90';
    case 'left':
      return 'transform rotate-0';
    case 'right':
      return 'transform rotate-180';
    case 'top-left':
      return 'transform rotate-45';
    case 'top-right':
      return 'transform rotate-[135deg]';
    case 'bottom-right':
      return 'transform -rotate-[135deg]';
    case 'bottom-left':
      return 'transform -rotate-45';
    default:
      return '';
  }
});
</script>

<template>
  <BaseIcon :size="size" viewBox="0 0 24 24" fill="none" :class="directionClass">
    <path
      d="M5 12H19"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 7L5 12"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 17L5 12"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </BaseIcon>
</template>
